<template>
  <ion-page>
    <main-header :back-href="backHref"></main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <div
          v-if="!order"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          This order is not available.
        </div>
        <ion-list v-else data-cy="order-details">
          <ion-item>
            <ion-label>
              {{ order.locationName }}
              <p>{{ order.friendlyIdentifier() }}</p>
            </ion-label>
            {{ order.requested ? order.requested.toLocaleString() : "" }}<br />
          </ion-item>
          <ion-item
            v-for="(lineItem, index) in order.items"
            :key="`item-${index}`"
            :data-cy="`order-item-${lineItem.id}`"
          >
            <ion-text slot="start">
              {{ lineItem.quantity }}
            </ion-text>
            <ion-label>
              {{ lineItem.name }}
              <span v-if="lineItem.options">
                - {{ lineItem.options.value.name }}
              </span>
              <p v-if="lineItem.instructions">{{ lineItem.instructions }}</p>
            </ion-label>
            {{ lineItem.totalPrice | usd }}
          </ion-item>
          <ion-item>
            <ion-label>
              <p>Service Charge</p>
            </ion-label>
            {{ order.serviceCharge | usd }}
          </ion-item>
          <ion-item>
            <ion-label>Total</ion-label>
            <strong>{{ order.totalPrice | usd }}</strong>
          </ion-item>
          <ion-item>
            <ion-label v-if="order.isDelivery()">
              Section: {{ order.section }}, Row: {{ order.row }}, Seat:
              {{ order.seat }}
              <p v-if="order.instructions">{{ order.instructions }}</p>
            </ion-label>
            <ion-label v-else>
              Pickup:
              <p>{{ order.pickupInstructions }}</p>
            </ion-label>
            <ion-badge>{{ order.status | ucfirst }}</ion-badge>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
// there are some similarties in the template here compared to OrderReview - so if more changes happen
// might make sense to combine them somehow - but it's not purely straight forward cuz you can modify quantity

import errorAlert from "@/ErrorAlert";
import Order from "@/models/Order";

export default {
  title: "Order Details",

  data: function() {
    return {
      loading: true,
      order: null
    };
  },

  created() {
    const orderId = this.$route.params.id;

    this.$firestore()
      .collection("orders")
      .withConverter(Order.firebaseConverter)
      .doc(orderId)
      .get()
      .then(result => {
        this.order = result.data();
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {
    backHref() {
      return this.$router.resolve({
        name: "App: Order History"
      }).href;
    }
  }
};
</script>
